import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router";
import AddTeam from "~Features/Team/AddTeam";
import type { Entity } from "~types/entity";
import QuickLink from "./QuickLink";

const AddEntityLink = () => {
  const [isAddEntityModalOpen, setIsAddEntityModalOpen] = useState(false);
  const { formatMessage } = useIntl();
  const { customerId, sport, organizationId } = useParams();
  const navigate = useNavigate();
  const navigateToEntityDetailsPage = (entity: Entity) =>
    navigate(`/${customerId}/admin/${sport}/${organizationId}/entities/manage/${entity.entityId}`);

  return (
    <>
      <QuickLink
        title={formatMessage({ id: "entity.add.quickLink.title" })}
        description={formatMessage({ id: "entity.add.quickLink.description" })}
        handleClick={() => setIsAddEntityModalOpen(true)}
      />
      <AddTeam isModalOpen={isAddEntityModalOpen} handleClose={() => setIsAddEntityModalOpen(false)} onAdd={navigateToEntityDetailsPage} />
    </>
  );
};

export default AddEntityLink;
